"use strict";

var _objectSpread = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _createForOfIteratorHelper = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParsedType = exports.ZodParsedType = exports.objectUtil = exports.util = void 0;
var util;

(function (util) {
  util.assertEqual = function (_) {};

  function assertIs(_arg) {}

  util.assertIs = assertIs;

  function assertNever(_x) {
    throw new Error();
  }

  util.assertNever = assertNever;

  util.arrayToEnum = function (items) {
    var obj = {};

    var _iterator = _createForOfIteratorHelper(items),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        obj[item] = item;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return obj;
  };

  util.getValidEnumValues = function (obj) {
    var validKeys = util.objectKeys(obj).filter(function (k) {
      return typeof obj[obj[k]] !== "number";
    });
    var filtered = {};

    var _iterator2 = _createForOfIteratorHelper(validKeys),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var k = _step2.value;
        filtered[k] = obj[k];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return util.objectValues(filtered);
  };

  util.objectValues = function (obj) {
    return util.objectKeys(obj).map(function (e) {
      return obj[e];
    });
  };

  util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
  ? function (obj) {
    return Object.keys(obj);
  } // eslint-disable-line ban/ban
  : function (object) {
    var keys = [];

    for (var key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        keys.push(key);
      }
    }

    return keys;
  };

  util.find = function (arr, checker) {
    var _iterator3 = _createForOfIteratorHelper(arr),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var item = _step3.value;
        if (checker(item)) return item;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return undefined;
  };

  util.isInteger = typeof Number.isInteger === "function" ? function (val) {
    return Number.isInteger(val);
  } // eslint-disable-line ban/ban
  : function (val) {
    return typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
  };

  function joinValues(array) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " | ";
    return array.map(function (val) {
      return typeof val === "string" ? "'".concat(val, "'") : val;
    }).join(separator);
  }

  util.joinValues = joinValues;

  util.jsonStringifyReplacer = function (_, value) {
    if (typeof value === "bigint") {
      return value.toString();
    }

    return value;
  };
})(util || (exports.util = util = {}));

var objectUtil;

(function (objectUtil) {
  objectUtil.mergeShapes = function (first, second) {
    return _objectSpread(_objectSpread({}, first), second);
  };
})(objectUtil || (exports.objectUtil = objectUtil = {}));

exports.ZodParsedType = util.arrayToEnum(["string", "nan", "number", "integer", "float", "boolean", "date", "bigint", "symbol", "function", "undefined", "null", "array", "object", "unknown", "promise", "void", "never", "map", "set"]);

var getParsedType = function getParsedType(data) {
  var t = typeof data;

  switch (t) {
    case "undefined":
      return exports.ZodParsedType.undefined;

    case "string":
      return exports.ZodParsedType.string;

    case "number":
      return Number.isNaN(data) ? exports.ZodParsedType.nan : exports.ZodParsedType.number;

    case "boolean":
      return exports.ZodParsedType.boolean;

    case "function":
      return exports.ZodParsedType.function;

    case "bigint":
      return exports.ZodParsedType.bigint;

    case "symbol":
      return exports.ZodParsedType.symbol;

    case "object":
      if (Array.isArray(data)) {
        return exports.ZodParsedType.array;
      }

      if (data === null) {
        return exports.ZodParsedType.null;
      }

      if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
        return exports.ZodParsedType.promise;
      }

      if (typeof Map !== "undefined" && data instanceof Map) {
        return exports.ZodParsedType.map;
      }

      if (typeof Set !== "undefined" && data instanceof Set) {
        return exports.ZodParsedType.set;
      }

      if (typeof Date !== "undefined" && data instanceof Date) {
        return exports.ZodParsedType.date;
      }

      return exports.ZodParsedType.object;

    default:
      return exports.ZodParsedType.unknown;
  }
};

exports.getParsedType = getParsedType;